import { usePath } from '@arnold/common';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import { Features, OrganizationQuery } from '../../generated/hooks';
import { useFeatureFlag } from '../../lib/helpers/hooks';
import { isPulserSurvey } from '../../lib/helpers/pulser';
import { SurveysScreen } from './SurveysScreen';

interface IProps {
  organization: NonNullable<OrganizationQuery['organization']>;
}

export const PulserSurveysScreen: FC<IProps> = ({ organization }) => {
  const [t] = useTranslation('AuthorizedPage');
  const { pulserSurveysPath, pulserConversationSubjectsPath, surveysPath } = usePath();
  const hasPulserModule = useFeatureFlag(Features.PulserModule);

  if (!hasPulserModule) {
    return <Redirect to={surveysPath.createPath()} />;
  }

  return (
    <SurveysScreen
      organization={organization}
      heading={t('pulser')}
      headingIcom="heading-pulser"
      surveysBasePath={pulserSurveysPath.createPath()}
      schedulePath={pulserConversationSubjectsPath.createPath()}
      filterSurveys={isPulserSurvey}
    />
  );
};
